import { FormsFieldPreset, FieldCollectionType } from '@wix/forms-common'
import { COMPLEX_ADDRESS_ROLES } from '../../../../../../../constants/roles'
import { GeneralText } from '../../../general-fields/definitions/general-text'

export class ComplexAddressStreet extends GeneralText {
  public get fieldType(): FieldPreset {
    return FormsFieldPreset.COMPLEX_ADDRESS_STREET
  }

  public get role() {
    return COMPLEX_ADDRESS_ROLES.STREET
  }

  protected get crmLabel() {
    return this.translate(`fieldTypes.${FormsFieldPreset.COMPLEX_ADDRESS_STREET}`)
  }

  public get collectionFieldType() {
    return FieldCollectionType.TEXT
  }

  protected get data() {
    return {
      textType: 'text',
      placeholder: this.translate('complexAddress.street.defaultTitle'),
      type: 'TextInput',
      value: '',
    }
  }

  protected get mobileHints() {
    return {
      recommendedWidth: 260,
    }
  }
}
